<template>

<span>


         <label>  {{$t('shared.import_info')}}</label>
        <!-- BirthDate -->
          <v-menu
                  ref="birthDateMenu"
                  v-model="birthDateMenuOpen"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                      :value="user.birthDate|formatDate"
                      :label="$t('booking.user_info.user.birth_date_label')"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on">
              </v-text-field>
            </template>
            <v-date-picker
                    v-model="user.birthDate"
                    :active-picker.sync="activePicker"
                    :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                    min="1950-01-01"
                    @change="$refs.birthDateMenu.save(user.birthDate)">
            </v-date-picker>

          </v-menu>
        <br/>

        <!-- Address -->
        <h2>{{$t('booking.user_info.address.header')}}</h2>
        <div class="column">
          <!-- Street -->
          <v-text-field
                  v-model="user.address.street"
                  :rules="[v => !!v || 'Street is required']"
                  :label="$t('booking.user_info.address.street_label')"
          >
          </v-text-field>

          <v-text-field
                  v-model="user.address.city"
                  :rules="[v => !!v || 'City is required']"
                  :label="$t('booking.user_info.address.city_label')"
          >
          </v-text-field>

          <v-text-field
                  v-model="user.address.postalCode"
                  :rules="[v => !!v || 'Postal code is required']"
                  :label="$t('booking.user_info.address.postal_code_label')"
          >
          </v-text-field>

          <v-autocomplete
                  style="padding-top:1.1rem;"
                  v-model="user.address.country"
                  :items="countries"
                  item-text="name"
                  dense
                  :label="$t('booking.user_info.address.country_label')">
          </v-autocomplete>
        </div>

        <br/>

        <h2>{{$t('booking.user_info.driving_licence.header')}}</h2>
        <div class="column">
          <!-- Licence Number -->
          <v-text-field
                  v-model="user.driverInformation.driverLicence"
                  :rules="[v => !!v || 'Driving license number is required']"
                  :label="$t('booking.user_info.driving_licence.licence_number_label')"
          >
          </v-text-field>
          <!-- Delivration Date -->
          <v-menu
                  v-model="delivrationDateMenuOpen"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                      :value="user.driverInformation.delivrationDate|formatDate"
                      :label="$t('booking.user_info.driving_licence.delivrance_date_label')"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on">
              </v-text-field>
            </template>
            <v-date-picker
                    v-model="user.driverInformation.delivrationDate"
                    @input="delivrationDateMenuOpen = false">
            </v-date-picker>
          </v-menu>
          <!-- Delivration Authority -->
          <v-text-field
                  v-model="user.driverInformation.delivrationAuthority"
                  :label="$t('booking.user_info.driving_licence.delivrance_authority_label')">
          </v-text-field>
          <!-- Nationality -->
          <v-autocomplete
                  style="padding-top:1.1rem;"
                  v-model="user.driverInformation.nationality"
                  :items="nationalities"
                  dense
                  small-chips
                  :label="$t('booking.user_info.driving_licence.nationality_label')">
          </v-autocomplete>
        </div>


</span>

</template>

<script>
  import { nationalities, countries } from '@/shared/data';
  import { AuthApi } from '../services/api/auth'
  import { mapGetters } from 'vuex'
  import { UsersApi } from '../services/api/users'

  export default {
    name: 'UserExtratInfo',
    data () {
      return {
        birthDateMenuOpen: false,
        activePicker: null,
        delivrationDateMenuOpen: false,
        nationalities,
        countries,
      };
    },
    props: ['user'],
    watch: {
      birthDateMenuOpen (val) {
        val && setTimeout(() => this.activePicker = 'YEAR');
      }
    },
    methods: {

    },
    computed: {
      filteredNationalities () {
        return this.nationalities
          .filter(option => option
            .toString()
            .toLowerCase()
            .indexOf(this.user.driverInformation.nationality.toLowerCase()) >= 0
          );
      },
      filteredCountries () {
        return this.countries
          .filter(option => option && option.name
            .toString()
            .toLowerCase()
            .indexOf(this.user.address.country.toLowerCase()) >= 0
          );
      },
    },
    components: {},
    created: function () {
      console.log("UserExtratInfo",this.user)
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  @media (min-width: 960px) {
    .container {
      width: 66rem;
    }

    .padding-like-field {
      padding: 5.12rem 0 0 0;
    }

    .box {
      margin: 1rem 2rem !important;
    }

    .padding-comment {
      padding: 1rem 10rem !important;
    }
  }

  .padding-top {
    padding-top: 4rem;
  }

  .padding-comment {
    padding: 0.8rem;
  }

  .box {
    margin: 0.3rem;
  }


</style>
